/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticValueShelfItem,
  AnimaticValueShelfItem$inboundSchema,
} from "./animaticvalueshelfitem.js";
import {
  ConditionExpression,
  ConditionExpression$inboundSchema,
} from "./conditionexpression.js";

/**
 * A single state for the value.
 */
export type AnimaticValueStateConfig = {
  /**
   * Defines a condition expression. Can be a single condition, a group of conditions, or nested groups. Exactly one of 'condition', 'condition_group', or 'nested_expression' must be specified.
   */
  conditionExpression?: ConditionExpression | undefined;
  /**
   * The configuration of the shelf item.
   */
  config: AnimaticValueShelfItem;
  /**
   * Whether this state is the default state. If this is true, conditions are not required. For readability, these states should be at the end of the array.
   */
  isDefault: boolean;
  /**
   * The priority of the state. There is no constraint on overlapping conditions, so this field allows user to set priority.
   */
  priority: number;
  /**
   * The name of the state
   */
  stateName: string;
};

/** @internal */
export const AnimaticValueStateConfig$inboundSchema: z.ZodType<
  AnimaticValueStateConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  condition_expression: types.optional(ConditionExpression$inboundSchema),
  config: AnimaticValueShelfItem$inboundSchema,
  is_default: types.boolean().default(false),
  priority: types.number().default(0),
  state_name: types.string(),
}).transform((v) => {
  return remap$(v, {
    "condition_expression": "conditionExpression",
    "is_default": "isDefault",
    "state_name": "stateName",
  });
});

export function animaticValueStateConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueStateConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueStateConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueStateConfig' from JSON`,
  );
}
